import React, { useState } from "react";
import MessageListPanel from "./MessageListPanel";
import OpenMessageCard from "./OpenMessageCard";

const MessagesBoard = ({ messages, starredMessages, toggleStar, onSelectMessage }) => {
  const [selectedMessage, setSelectedMessage] = useState(messages[0]);

  const handleSelect = (message) => {
    setSelectedMessage(message);
    onSelectMessage(message);
  };

  return (
    <div className="flex flex-col space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="col-span-1">
          <MessageListPanel
            messages={messages}
            selectedMessage={selectedMessage}
            onSelect={handleSelect}
            starredMessages={starredMessages}
            onToggleStar={toggleStar}
          />
        </div>

        <div className="col-span-2 space-y-6">
          {selectedMessage && (
            <OpenMessageCard
              message={selectedMessage}
              isStarred={starredMessages[selectedMessage.id]}
              onToggleStar={() => toggleStar(selectedMessage.id)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MessagesBoard;
